import styled from "styled-components"

export const AnchorStyles = styled.a`
  display: block;
  width: 179.41px;
  background-color: #f7f2e8;
  font-size: 18px;
  font-weight: 700;
  line-height: 2.5em;
  padding: 2px 3em 0;
  border: 2px solid #f8b3ad;
  color: #f8b3ad;
  text-decoration: none;
  border-radius: 2em;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  margin: 30px 0;
  text-decoration: none;
`

export const Button = styled.button`
  display: block;
  background-color: #f8b3ad;
  font-size: 18px;
  font-weight: 700;
  line-height: 2.5em;
  padding: 2px 3em 0;
  border: 2px solid #fed9ad;
  color: #fed9ad;
  text-decoration: none;
  border-radius: 2em;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  margin: 30px 0;
  text-decoration: none;
  cursor: pointer;
`
